import { Resolve, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LookupService } from './lookup.service';
import { Country,
         Relationship,
         VisaSubClass,
         OHSCProvider,
         EnglishTestType,
         YearOfEntry,
         SchoolSubject,
         School,
         Term,
         IecDuration,
         SchoolDuration} from '../models/lookup-data.model';
import { ParentGuardianDetails } from 'src/app/application/models/parent-guardian-details';
import { ApplicationService } from './application.service';
import { map } from 'rxjs/operators';
import { Summary } from 'src/app/application/models/summary.model';
import { SummaryWithSupportingDocuments } from 'src/app/application/models/summary-with-supporting-documents';


@Injectable()
export class CountryResolverService implements Resolve<Country[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<Country[]> {
        return this.lookupService.getCountries();
    }
}

@Injectable()
export class ParentGuardianResolverService implements Resolve<ParentGuardianDetails[]> {

    constructor(private applicationService: ApplicationService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<ParentGuardianDetails[]> {
        const applicationId = route.parent.parent.paramMap.get('id');
        return this.applicationService.getParentGuardiansDetails(+applicationId)
            .pipe(map(apiResponse => {
                if (apiResponse.Errors && apiResponse.Errors.length > 0) {
                    return null;
                } else if ( apiResponse.Result) {
                    return <ParentGuardianDetails[]> apiResponse.Result;
                }
            }));
    }
}



@Injectable()
export class RelationshipTypesResolverService implements Resolve<Relationship[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<Relationship[]> {
        return this.lookupService.getRelationshipTypes();
    }
}

@Injectable()
export class VisaSubClassesResolverService implements Resolve<VisaSubClass[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<VisaSubClass[]> {
        return this.lookupService.getVisaSubClasses();
    }
}


@Injectable()
export class OHSCProvidersResolverService implements Resolve<OHSCProvider[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<OHSCProvider[]> {
        return this.lookupService.getOHSCProviders();
    }
}


@Injectable()
export class EnglishTestTypesResolverService implements Resolve<EnglishTestType[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<EnglishTestType[]> {
        return this.lookupService.getEnglishTestTypes();
    }
}


@Injectable()
export class YearsOfEntryResolverService implements Resolve<YearOfEntry[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<YearOfEntry[]> {
        return this.lookupService.getYearsOfEntry();
    }
}


@Injectable()
export class SchoolSubjectResolverService implements Resolve<SchoolSubject[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<SchoolSubject[]> {
        return this.lookupService.getSchoolSubjects();
    }
}


@Injectable()
export class SchoolsResolverService implements Resolve<School[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<School[]> {
        return this.lookupService.getSchools();
    }
}

@Injectable()
export class TermsResolverService implements Resolve<Term[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<Term[]> {
        return this.lookupService.getTerms();
    }
}


@Injectable()
export class DurationsResolverService implements Resolve<IecDuration[]> {

    constructor(private lookupService: LookupService) {}

    resolve(): Observable<IecDuration[]> {
        return this.lookupService.getDurations();
    }
}

@Injectable()
export class SummaryResolverService implements Resolve<any> {

    constructor(private applicationService: ApplicationService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<Summary> {
        const applicationId = route.parent.paramMap.get('id');
        return this.applicationService.getSummary(+applicationId)
            .pipe(map(apiResponse => {
                if (apiResponse.Errors && apiResponse.Errors.length > 0) {
                    return null;
                } else if ( apiResponse.Result) {
                    return <Summary> apiResponse.Result;
                }
            }));
    }
}

@Injectable()
export class SummaryWithDocumentsService implements Resolve<any> {
    constructor(private applicationService: ApplicationService) {        
    }

    resolve(route: ActivatedRouteSnapshot): Observable<SummaryWithSupportingDocuments> {
        const applicationId = route.parent.paramMap.get('id');
        return this.applicationService.getSummaryWithSupportingDocuments(+applicationId)
            .pipe(map(apiResponse => {
                if (apiResponse.Errors && apiResponse.Errors.length > 0) {
                    return null;
                } else if ( apiResponse.Result) {
                    return <SummaryWithSupportingDocuments> apiResponse.Result;
                }
            }));
    }
}




